import React, { Component } from 'react';
import { BeatLoader } from 'react-spinners';

import { PageTitle } from 'components/pages/pageTitle';
import { TableContainer } from './table/MoEventsListTable';
import { callApi } from 'helpers/callApi/callApi';
import { MoEventsListProps, MoEventsListState } from './MoEventsList.types';

export class MoEventsList extends Component<MoEventsListProps, MoEventsListState> {
  constructor(props: MoEventsListProps) {
    super(props);

    this.state = {
      data: undefined,
      error: false,
    };
  }

  componentDidMount(): void {
    const { fetch } = this.props;

    callApi({
      action: fetch,
      onSuccess: ({ payload }) => {
        this.setState({ data: payload });
      },
      onFailure: () => {
        this.setState({ error: true, data: [] });
      },
    });
  }

  render() {
    const { data, error } = this.state;

    return (
      <>
        <PageTitle displayTitle="Marching Orders Events" />
        {error && <div>Something went wrong</div>}
        {!!data || <BeatLoader />}
        {!!data && !!data.length && <TableContainer data={data} />}
      </>
    );
  }
}
